import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../../../../components/animated-link/AnimatedLink';
import { AutocompleteTips } from './AutocompleteTips';
import { SearchAutocomplete } from './SearchAutocomplete';
import { TypeSelectorScrollable } from '../../type-selector-scrollable/TypeSelectorScrollable';

type Props = {
  query: string;
  isLoggedIn: boolean;
  onItemSelected: Function;
  updateQuery: Function;
  manualClose: Function;
  onSelection: Function;
  enableTypeSelector: boolean;
  allowEmptyQuery: boolean;
};

export const SearchDropdown: FC<Props> = ({
  query,
  isLoggedIn,
  onItemSelected,
  updateQuery,
  manualClose,
  onSelection,
  enableTypeSelector,
  allowEmptyQuery,
}) => {
  const isHistoryMode = isLoggedIn && query.length === 0;
  const isDemoMode = query.length === 0 && !isLoggedIn;
  const isAutocompleteMode = query.length > 0 || isLoggedIn;

  return (
    <div className="search-bar-dropdown">
      {enableTypeSelector && (
        <TypeSelectorScrollable onSelection={onSelection} />
      )}

      {isAutocompleteMode && (
        <SearchAutocomplete
          query={query}
          onItemSelected={onItemSelected}
          updateQuery={updateQuery}
          manualClose={manualClose}
          isHistoryMode={isHistoryMode}
          isDemoMode={isDemoMode}
          allowEmptyQuery={allowEmptyQuery}
        />
      )}

      {isHistoryMode && (
        <div className="search-bar-dropdown__cell search-bar-dropdown__history">
          <AnimatedLink
            component={Link}
            to="/historique_recherches?source=autocomplete"
          >
            <FormattedMessage id="search/components/search-bar/dropdown/SearchAutocompleteList.tsx/2" />
          </AnimatedLink>
        </div>
      )}
      <AutocompleteTips />
    </div>
  );
};
